import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthUsersGuard} from '../../../resources/guards/authUsers.guard';
import {IconDollarComponent} from '../../../resources/components/icons/icon-dollar/icon-dollar.component';
import {PurchasesComponent} from '../purchases.component';
import {PurchaseIndexComponent} from '../purchase-index/purchase-index.component';
import {routerHandler} from "../../../resources/utils/router";
import {UserViewComponent} from "../../users/user-view/user-view.component";
import {UserViewChildrenRoutes} from "../../users/user-view/user-view-children.routes";
import {StoreViewComponent} from "../../stores/store-view/store-view.component";
import {StoreViewChildrenRoutes} from "../../stores/store-view/store-view-children.routes";
import {ProductViewComponent} from "../../products/product-view/product-view.component";
import {ProductViewChildrenRoutes} from "../../products/product-view/product-view-children.routes";

export const PurchaseRoutes: Routes = [

  {
    path: 'purchases',
    data: {
      title: 'Purchases',
      breadcrumbs: 'Purchases',
      icon: IconDollarComponent
    },
    component: PurchasesComponent,
    canActivate: [AuthUsersGuard],
    children: [
      routerHandler.index('purchase', {
        component: PurchaseIndexComponent
      }),
      routerHandler.view('user', {
        component: UserViewComponent, children: UserViewChildrenRoutes, prefix: true
      }),
      routerHandler.view('store', {
        component: StoreViewComponent, children: StoreViewChildrenRoutes, prefix: true
      }),
      routerHandler.view('product', {
        component: ProductViewComponent, children: ProductViewChildrenRoutes, prefix: true
      }),
    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(PurchaseRoutes)],
  exports: [RouterModule]
})
export class PurchasesRoutesModule {
}
